import { Component } from '@angular/core';


@Component({
    selector: 'soft-detail-page',
    imports: [],
    templateUrl: './detail-page.component.html',
    styleUrl: './detail-page.component.css'
})
export class DetailPageComponent {}
